module.exports = __webpack_public_path__ + "static/media/landing-slider-img-1-mobile.dbf321af.jpg";